/**
 * The in-player status chip: what is actually happening to this stream.
 *
 * Sniffs the URL that is genuinely being played, which is the subtlety that
 * bit us. When mpv owns playback in the desktop shell, the player still holds
 * the browser's `url` prop (a `/transmux/` URL) while mpv plays the upstream —
 * so labelling from `url` reported "transmuxed" during playback that involved
 * no transmuxing at all. Pass what is really playing, and say so.
 */
export function streamSourceLabel(url: string, viaMpv = false): string {
  if (!url) return "";
  if (viaMpv) {
    // Native decode straight from the source: no ffmpeg, no proxy hop.
    try {
      return `native · ${new URL(url).hostname}`;
    } catch {
      return "native";
    }
  }
  const lower = url.toLowerCase();
  if (lower.includes("/transmux/")) return "transmuxed";
  if (lower.startsWith("/api/") || lower.includes("/api/playlists/")) return "via proxy";
  try {
    const u = new URL(url, typeof window !== "undefined" ? window.location.href : "https://localhost");
    return `direct · ${u.hostname}`;
  } catch {
    return "direct";
  }
}
